// Notifications service - connects to real Google Sheets
import googleSheetsAPI from './googleSheetsAPI';

class NotificationsService {
  constructor() {
    this.googleSheets = googleSheetsAPI;
  }

  /**
   * Fetch all active notifications from Google Sheets
   */
  async getActiveNotifications() {
    try {
      // Fetch real data from Google Sheets
      const notifications = await this.googleSheets.getActiveNotifications();
      
      // Transform the data to match our expected format
      return notifications.map(notification => ({
        id: parseInt(notification.id) || 0,
        title: notification.title || '',
        message: notification.message || '',
        emoji: notification.emoji || '🔔',
        scheduledDate: notification.scheduleddate || '',
        show24HoursBefore: notification.show24hoursbefore?.toLowerCase() === 'true',
        active: notification.active?.toLowerCase() === 'true'
      }));
      
    } catch (error) {
      console.error('Error fetching notifications from Google Sheets:', error);
      // Fallback to empty array if there's an error
      return [];
    }
  }

  /**
   * Mark notification as read/inactive (local state only)
   * Note: This doesn't update the Google Sheet, just removes from local display
   */
  markAsRead(id) {
    // In a real implementation, you might want to track read notifications
    // For now, this is handled by the component state
    console.log(`Marked notification ${id} as read`);
    return true;
  }

  /**
   * Get notification count
   */
  async getNotificationCount() {
    const notifications = await this.getActiveNotifications();
    return notifications.length;
  }
}

// Export singleton instance
export default new NotificationsService();
